<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                  <label>País</label>
                                  <select-api
                                      v-model="filter.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                                </div>
                            </div>

                            <hr />
                        </div>
                        <div class="card-footer">
                            <div class="form-group row">
                                <div class="col-md-6 text-left">
                                    <button type="button" @click="create" class="btn btn-primary">
                                        Nova Página
                                        <i class="fa fa-angle-right"></i>
                                    </button>
                                </div>
                                <div class="col-md-6 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                            <tbody>
                                <tr v-for="item in list.rows" :key="item.toString('hex')">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">
                                      {{ item.nome }}

                                      <span
                                          v-if="item.ativo"
                                          class="badge badge-success"
                                      >Ativo</span>
                                      <span v-else class="badge badge-danger">Inativo</span>
                                    </td>
                                    <td :data-label="headers[2].name">{{ item.codigo }}</td>
                                    <td :data-label="headers[3].name">{{ item.pais.nome }}</td>
                                    <td>
                                        <button
                                            class="btn btn-primary btn-sm"
                                            @click="edit(item.id)"
                                        >
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="remove(item.id)"
                                        >
                                            <i class="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
} from "@/services/string";
import SelectApi from "../../components/Input/SelectApi";
import Facade from "../../facade/facade";
const facade = new Facade();

export default {
    components: { SelectApi },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Nome", key: "nome" },
                { name: "Código", key: "codigo" },
                { name: "País", key: "pais.id" }
            ],
            list: {},
            filter: {
              id_pais: ''
            },
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            model: {}
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        clean() {
            this.filter = {};
        },
        create() {
            this.$router.push({ name: "new-page" });
        },

        edit(id) {
            this.$router.push({
                name: "edit-page",
                params: { id: id }
            });
        },

        remove(id) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Não será possível  reverter esta operação",
                showCancelButton: true,
                confirmButtonText: "Sim, deletar!",
                cancelButtonText: "Não, cancelar!"
            }).then(
                () => {
                    this.$loading.show(true);

                    let ret = facade.deletePage(id);
                    ret.then(response => {
                        this.$notify.success(
                            "",
                            "Registro removido com sucesso."
                        );
                        this.fetchData(0);
                        this.$loading.show(false);
                    }).catch(e => {
                        this.$notify.error(
                            "Erro!",
                            "Ocorreu um problema ao deletar o registro."
                        );
                        this.$loading.show(false);
                    });
                },
                dismiss => {}
            );
        },

        fetchData(page) {
            let vm = this;
            vm.page = page;

            let params = {
                params: {
                    page: page,
                    size: vm.size,
                    order: vm.order
                }
            };
            for (let key in this.filter) {
                if (this.filter.hasOwnProperty(key)) {
                    params["params"][key] = this.filter[key];
                }
            }

            this.$loading.show(true);
            let ret = facade.listPage(params);
            ret.then(response => {
                vm.list = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar."
                );
                this.$loading.show(false);
            });
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?4b07159e